//
//
//
//
//
//
//

import {events} from '@nuskin/ns-util';

export default {
  name: 'ProductPage',
  data() {
    return {};
  },
  computed: {
    contentstackLocale() {
      return this.$store.getters['nuskin/contentstackLocale'] || '';
    },
    slug() {
      return this.$route.params.slug || '';
    },
    variantSlug() {
      return this.$route.query.variant;
    }
  },
  watch: {
    contentstackLocale: {
      immediate: true,
      handler(value) {
        this.$i18n.setLocale(value);
        events.publish('updateHeaderLanguage');
      }
    }
  }
};
